import React from "react";
import styles from "./SeasonalTravelDestinationPlan.module.scss";
export function DestinationPlanHeader(props) {
  return /*#__PURE__*/React.createElement("div", {
    className: styles.planHeader
  }, /*#__PURE__*/React.createElement("h2", null, props.destination_title), /*#__PURE__*/React.createElement("p", null, props.destination_description));
}